import React, { useEffect, useRef, useState } from 'react';
import { Ssvg } from '../../../../Components/react/Ssvg';
import { MEDIA_BREAKPOINTS } from '../../../../constants/MEDIA_BREAKPOINTS';
import SocialSharingItems from './SocialSharingItems';
export const SocialSharing = () => {
    const [opened, setOpened] = useState(false);
    const containerRef = useRef(null);
    const itemsRef = useRef(null);
    useEffect(() => {
        if (MEDIA_BREAKPOINTS.XL_UP.matches || !opened)
            return;
        const handleDocClick = (e) => {
            e.target instanceof Element &&
                itemsRef.current?.contains(e.target) !== true &&
                setOpened(false);
        };
        document.body.addEventListener('click', handleDocClick);
        return () => {
            document.body.removeEventListener('click', handleDocClick);
        };
    }, [opened]);
    return (React.createElement("div", { className: "pos:r lh:0 py:2 py:6:xl-up ml:10", ref: containerRef, ...MEDIA_BREAKPOINTS.XL_UP.matches &&
            {
                onMouseEnter: () => { setOpened(true); },
                onMouseLeave: () => { setOpened(false); }
            } },
        React.createElement("span", { className: "d:block pos:r z:4 cursor:pointer", ...!MEDIA_BREAKPOINTS.XL_UP.matches &&
                {
                    onClick: (e) => {
                        if (!opened) {
                            e.stopPropagation();
                            setOpened(true);
                        }
                    }
                } },
            React.createElement(Ssvg, { icon: "#icon--share--b", className: "h:20" })),
        opened &&
            React.createElement(SocialSharingItems, { itemsRef: itemsRef })));
};
